import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { InfoBanner } from '@beef/smart-kit';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { getLeavePhoneBlockSubTitle } from "../../../store/selectors/leavePhone";
import { templateParser } from "../../../utils/catalogUtils";
import { NText } from "../../ui/common";
import { getCaptchaFlag } from "../../../store";
import styles from "./styles.pcss";
import { BackCallBlock } from "./components/BackCallBlock";
var cx = classNames.bind(styles);
export var _LeaveYourPhone = function _LeaveYourPhone(_ref) {
  var leavePhoneData = _ref.leavePhoneData,
    callBackRequestData = _ref.callBackRequestData,
    text = _ref.text,
    showCaptcha = _ref.showCaptcha,
    pageType = _ref.pageType,
    isConvergent = _ref.isConvergent,
    isPersonalVerificationCheckboxEnable = _ref.isPersonalVerificationCheckboxEnable;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('banner'),
    "data-t-id": "legacy-LeaveYourPhone"
  }, /*#__PURE__*/React.createElement(InfoBanner, _extends({}, leavePhoneData, {
    text: text
  }), callBackRequestData && /*#__PURE__*/React.createElement(BackCallBlock, {
    data: callBackRequestData,
    isConvergent: isConvergent,
    isPersonalVerificationCheckboxEnable: isPersonalVerificationCheckboxEnable,
    pageType: pageType,
    showCaptcha: showCaptcha
  }), (leavePhoneData === null || leavePhoneData === void 0 ? void 0 : leavePhoneData.footnote) && /*#__PURE__*/React.createElement(NText, {
    className: "mar-t-xl",
    color: "grey60",
    size: "size5-r-l"
  }, leavePhoneData.footnote)));
};
_LeaveYourPhone.propTypes = process.env.NODE_ENV !== "production" ? {
  isPersonalVerificationCheckboxEnable: PropTypes.bool,
  leavePhoneData: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),
  text: PropTypes.node,
  callBackRequestData: PropTypes.shape({
    texts: PropTypes.shape({})
  }),
  showCaptcha: PropTypes.bool,
  pageType: PropTypes.string,
  isConvergent: PropTypes.bool
} : {};
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    text: templateParser(getLeavePhoneBlockSubTitle(state), {
      phoneNumbers: ownProps.phone
    }),
    showCaptcha: getCaptchaFlag(state)
  };
};
export var LeaveYourPhone = connect(mapStateToProps)(_LeaveYourPhone);